import Vue from 'vue'
import VueAgile from 'vue-agile'

Vue.use(VueAgile)
